const cardTypeOCR = {
  firstGeneration: '第一代身份证',
  frontSecondGeneration: '第二代身份证正面',
  backSecondGeneration: '第二代国民身份证背面',
  chinaTemporary: '中国临时身份证',
  bankCard: '银行卡',
};

export default cardTypeOCR;
